'use strict';

export default function f($rootScope, modal, development, userModel, Storage) {
  'ngInject';

  // sa_booking_pay_modal
  const PAY_MODAL_KEY = 'sa_bpm';
  const THREE_HOURS = 10800000;
  const COOKIE_EXPIRATION = THREE_HOURS;
  var storage = new Storage('cookie');

  var timePassed = function() {
    var key = PAY_MODAL_KEY;
    var data = storage.get(key);
    if (data) {
      return false;
    } else {
      storage.set(key, 1,
        { expires: new Date(new Date().getTime() + COOKIE_EXPIRATION) });
      return true;
    }
  };

  return {
    open: function (conversation) {
      if (development.disablePopUps()) { return; }
      // Mind the order!
      var payBookingStatus = conversation.booking.status === 'accept';

      var offerShowPayConversation = false;
      if (conversation.booking.status === 'offer_accept') {
        var offerAccept = conversation.$messages.filter((message) => {
          if (message.action === 'offer_accept') {
            return true;
          }
        })[0];

        var offerAcceptSentAt;
        if (offerAccept) {
          offerAcceptSentAt = offerAccept.sentAt;
        } else {
          return;
        }

        var sentMessageCount = conversation.$messages.filter((message) => {
          if (message.$type === 'message'
            && message.sender === userModel.item.id
            && message.sentAt > offerAcceptSentAt) {
            return true;
          }
        }).length;

        var receivedMessageCount = conversation.$messages.filter((message) => {
          if (message.$type === 'message'
            && message.sender !== userModel.item.id
            && message.sentAt > offerAcceptSentAt) {
            return true;
          }
        }).length;

        if (receivedMessageCount >= 1 && sentMessageCount >= 2) {
          offerShowPayConversation = true;
        }
      }

      var paidBooking;
      try {
        paidBooking = conversation.booking.guestPriceInfo.amount;
      } catch (e) {
        paidBooking = false;
      }

      var traveller = conversation.booking.guideId !== userModel.item.id;
      var wrongConditions = !((payBookingStatus || offerShowPayConversation) && paidBooking && traveller);
      if (wrongConditions) {
        return;
      } else if (!timePassed()) { return; }

      var scope = $rootScope.$new();
      scope.conversation = conversation;

      return modal.open({
        template: '<sa-pay-conversation-modal conversation="conversation" done="close()"></sa-pay-conversation-modal>',
        scope: scope
      }).result;

    }
  };
}



// WEBPACK FOOTER //
// ./app/src/components/pay_conversation_modal/pay_conversation_modal.service.js